export default function ({ store, redirect, query, route }) {
  const isSubscriber = store.getters['user/isSubscriber']

  if (!isSubscriber) {
    return redirect('/login', {
      ...query,
      redirect: route.path
    })
  }
}
